"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownTabs = void 0;
const react_1 = __importStar(require("react"));
const react_resize_detector_1 = require("react-resize-detector");
const TabControl_1 = require("../TabControl");
const common_1 = require("../common");
const DropdownTabs_styles_1 = require("./DropdownTabs.styles");
const menuTab = { id: 'menu-tab', label: 'menu' };
const mapTabWidthPlusOffset = ([_, tabWidth]) => tabWidth + DropdownTabs_styles_1.TAB_OFFSET;
const DropdownTabsInner = (_a, externalTabListRef) => {
    var { tabs: initTabs = [], activeTab, onActivate, elevation = 1, getTabControlId, getTabPanelId, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, renderAsNav = false } = _a, restProps = __rest(_a, ["tabs", "activeTab", "onActivate", "elevation", "getTabControlId", "getTabPanelId", 'aria-label', 'aria-labelledby', "renderAsNav"]);
    const tabs = (0, common_1.useTabObjects)(initTabs);
    const { 'aria-orientation': ariaOrientation, onKeyDown } = (0, common_1.useFocusManager)({
        orientation: 'horizontal'
    });
    /*
     * Using a ref here so we can store the elements as they are initially rendered.
     * This allows us to always have a reference to their rendered size even after
     * we pull them out of the dom and hide the elements that overflow the tab bar.
     * This is assuming the tab elements themselves don't ever change their dimensions
     * based on the screen size.
     */
    const tabsRef = (0, react_1.useRef)({
        tabs: [],
        totalWidth: 0
    });
    const [numVisibleTabs, setNumVisibleTabs] = (0, react_1.useState)(tabs.length);
    const [selectedMenuTab, setSelectedMenuTab] = (0, react_1.useState)(null);
    const [rowTabs, setRowTabs] = (0, react_1.useState)(tabs);
    const [menuTabs, setMenuTabs] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        setRowTabs(tabs.slice(0, numVisibleTabs));
        setMenuTabs(tabs
            .slice(numVisibleTabs)
            .filter((tab) => selectedMenuTab == null || !(0, common_1.doTabsMatch)(selectedMenuTab, tab)));
    }, [selectedMenuTab, tabs, numVisibleTabs]);
    const { width, ref } = (0, react_resize_detector_1.useResizeDetector)({
        refreshMode: 'debounce',
        refreshRate: 500,
        handleHeight: false
    });
    const menuTabRef = (el) => {
        if (el && tabsRef.current && width) {
            setNumVisibleTabs((0, common_1.calcVisibleTabs)(
            // Factoring in an additional offset for each tab so that they can be displayed comfortably
            tabsRef.current.tabs.map(mapTabWidthPlusOffset), {
                totalTabsWidth: tabsRef.current.totalWidth,
                available: width,
                // have to reserve extra space as the menuTab has been added to the row
                reserved: DropdownTabs_styles_1.RESERVED_WIDTH + DropdownTabs_styles_1.RESERVED_OFFSET + el.offsetWidth
            }));
        }
    };
    const setTabRef = (tab, tabsLength, tabsRef) => (el) => {
        if (el !== null &&
            tabsRef &&
            tabsRef.current &&
            tabsRef.current.tabs.length < tabsLength) {
            const key = (0, common_1.getTabId)(tab);
            tabsRef.current.tabs.push([key, el.offsetWidth]);
            tabsRef.current.totalWidth += el.offsetWidth;
        }
    };
    (0, react_1.useEffect)(() => {
        if (width && tabsRef.current) {
            const nextVisibleTabs = (0, common_1.calcVisibleTabs)(tabsRef.current.tabs.map(mapTabWidthPlusOffset), {
                totalTabsWidth: tabsRef.current.totalWidth,
                available: width,
                reserved: DropdownTabs_styles_1.RESERVED_WIDTH + DropdownTabs_styles_1.RESERVED_OFFSET
            });
            setSelectedMenuTab(null); // TODO make this smarter so we can maintain the selected menu tab on resize
            setNumVisibleTabs(nextVisibleTabs);
        }
    }, [width, activeTab]);
    /**
     * This useEffect swaps the last row tab with active tab,
     * only if, the activeTab is not visible in row
     */
    (0, react_1.useEffect)(() => {
        if (activeTab && !rowTabs.some((tab) => (0, common_1.doTabsMatch)(tab, activeTab))) {
            const tabToSwap = tabs.find((tab) => (0, common_1.doTabsMatch)(tab, activeTab));
            if (tabToSwap) {
                const { newRowTabs, newMenuTabs } = (0, common_1.swapLastRowTabWithActiveTab)(rowTabs, menuTabs, tabToSwap);
                setRowTabs(newRowTabs);
                setMenuTabs(newMenuTabs);
            }
        }
    }, [numVisibleTabs, activeTab, rowTabs, menuTabs, tabs]);
    const handleOnClick = (tab) => (event) => {
        event.persist();
        if (tab.id !== menuTab.id) {
            if (!renderAsNav) {
                event.preventDefault();
            }
            onActivate && onActivate(event, tab.id, tab);
        }
    };
    const handleMenuItemClick = (event, tab) => {
        event.persist();
        setSelectedMenuTab(tab);
        onActivate && onActivate(event, tab.id, tab);
    };
    const normalizedTabListRef = (0, common_1.useNormalizedRefs)(externalTabListRef, ref);
    const tabListRole = renderAsNav ? 'navigation' : 'tablist';
    return (react_1.default.createElement(DropdownTabs_styles_1.TabList, Object.assign({ as: renderAsNav ? 'nav' : undefined, ref: normalizedTabListRef, role: tabListRole, "aria-orientation": ariaOrientation, elevation: elevation, tabIndex: -1, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, onKeyDown: renderAsNav ? undefined : onKeyDown }, restProps),
        rowTabs.map((tab, i) => {
            const tabControlId = getTabControlId(tab.id);
            const selected = (0, common_1.doTabsMatch)(tab, activeTab);
            const tabIndex = (0, common_1.getTabIndex)(activeTab, selected, i);
            return (react_1.default.createElement(TabControl_1.TabControl, { getTabPanelId: getTabPanelId, handleOnClick: () => handleOnClick(tab), key: tab.id, ref: setTabRef(tab, rowTabs.length, tabsRef), renderAsNav: renderAsNav, selected: selected, tab: tab, tabControlId: tabControlId, tabIndex: tabIndex, useWithDropdown: true }));
        }),
        selectedMenuTab &&
            !(0, common_1.doTabsMatch)(selectedMenuTab, rowTabs[rowTabs.length - 1]) && ( // This covers an edge-case where it's possible to render the last tabs item alongside the menuTab, this hides the menuTab in that case
        react_1.default.createElement(TabControl_1.TabControl, { getTabPanelId: getTabPanelId, handleOnClick: () => handleOnClick(selectedMenuTab), key: selectedMenuTab.id, ref: menuTabRef, renderAsNav: renderAsNav, selected: (0, common_1.doTabsMatch)(selectedMenuTab, activeTab), tab: selectedMenuTab, tabControlId: getTabControlId(selectedMenuTab.id), tabIndex: (0, common_1.getTabIndex)(activeTab, (0, common_1.doTabsMatch)(selectedMenuTab, activeTab), rowTabs.length, renderAsNav), useWithDropdown: true })),
        rowTabs.length !== tabs.length && (react_1.default.createElement(DropdownTabs_styles_1.TabMenu, { role: renderAsNav ? 'link' : 'tab', id: menuTab.id, tabIndex: (0, common_1.getTabIndex)(activeTab, (0, common_1.doTabsMatch)(menuTab, activeTab), rowTabs.length + 1, renderAsNav), items: menuTabs, onClickItem: handleMenuItemClick, menuItemElement: renderAsNav ? 'a' : 'li' }, `+${menuTabs.length} more`))));
};
exports.DropdownTabs = (0, react_1.forwardRef)(DropdownTabsInner);
//# sourceMappingURL=DropdownTabs.js.map